import { useMediaQuery } from "./useMediaQuery"

const DEFAULT_MOBILE_BREAKPOINT = 768

/**
 * Returns true when viewport is below the provided breakpoint.
 * @category core
 *
 * @example
 * ```tsx
 * import { useIsMobile } from "@onnia/hooks"
 * const isMobile = useIsMobile()
 * ```
 */
export function useIsMobile(breakpoint: number = DEFAULT_MOBILE_BREAKPOINT): boolean {
    // Use media query directly to avoid reliance on window.innerWidth and to leverage SSR safety
    const isMobile = useMediaQuery(`(max-width: ${breakpoint - 1}px)`)
    return isMobile
}
